import './FortuneCookie.scss';
import { Helmet } from 'react-helmet';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useRef, useState } from 'react';
import Button from '../../components/Button/Button';
import TitleContentBlock from '../../components/TitleContentBlock/TitleContentBlock';
import fortuneData from '../../data/fortune-cookie.json';

function FortuneCookie() {
  const videoRef = useRef(null);
  const [isPlayed, setIsPlayed] = useState(false);
  const [fortune, setFortune] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(null);

  const getUniqueRandomIndex = () => {
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * fortuneData.length);
    } while (newIndex === previousIndex && fortuneData.length > 1);
    return newIndex;
  };

  const handleClick = () => {
    const video = videoRef.current;
    const newIndex = getUniqueRandomIndex();
    const newFortune = fortuneData[newIndex];

    setFortune(newFortune);
    setPreviousIndex(newIndex);

    video.pause();
    video.currentTime = 0;
    video.play();
    setIsPlayed(true);
  };

  return (
    <div className="page-layout">
      <Helmet>
        <title>Fortune cookie - Sony Chen</title>
        <meta name="description" content="An interactive fortune cookie experience by Sony Chen, blending playful design with thoughtful storytelling." />
      </Helmet>

      <Header />
      <main className="page-layout-main">
        <div className="page-layout-main__wrapper">
          <TitleContentBlock 
            header="Take Your " 
            headerUnderline="Fortune"
            isSparkle={true}
            body="Unlock a surprise message tied to one of my creative journeys."
          />

          <div className="fortune">
            <div className="fortune__video-container">
              <video
                ref={videoRef}
                className="fortune__video"
                src="https://res.cloudinary.com/dhifyp04n/video/upload/v1744524123/fortunecn_cfwwmo.mp4"
              />
            </div>

            {fortune && (
              <div className="fortune__content-container">
                <h2 className="fortune__header">{fortune.fortune}</h2>
                <a className="fortune__link" href={fortune.url} target="_blank" rel="noopener noreferrer">
                  {fortune.project}
                </a>
              </div>
            )}

            <Button text="Crack the Cookie" onClick={handleClick} />
          </div>
        </div>
        <Footer />
      </main>
    </div>
  );
}

export default FortuneCookie;